<div class="alert-wrapper" [class.alert-visible]="firstError" [class.alert-box-animation]="animate$ | async">
  <div class="alert alert-warning" role="alert">
    <ul *ngIf="firstError" class="errors-list">
      <!-- the first error is always visible if it represented -->
      <li>
        <p>
          <strong>{{ firstError?.code }}</strong> {{ firstError?.message | translate }}
        </p>
      </li>

      <!-- box with a list of errors from second to last. collapsed by default  -->
      <div class="collapse" id="errorSpoiler">
        <li *ngFor="let error of hiddenErrors">
          <p>
            <strong>{{ error?.code | translate }}</strong> {{ error?.message | translate }}
          </p>
        </li>
      </div>
    </ul>

    <div class="clearfix">
      <button
        *ngIf="hiddenErrors.length"
        class="btn btn-link alert-button pull-right"
        type="button"
        data-toggle="collapse"
        data-target="#errorSpoiler"
        (click)="toggleButtonCaption()"
      >
        {{ buttonCaption | translate}} <span *ngIf="isSpoilerCollapsed"> ({{ errors.length }})</span>
      </button>
    </div>
  </div>
</div>
